import { put } from 'redux-saga/effects';

import { IKnmDictionary } from 'APIPackage/KnmModule/interfaces/IKnmDictionary';
import { supervisionDictionaryValueGet } from 'CorePackage/DictionariesModule/actions/dictionariesActions';

export function* getSupervisionDictionaryValue(knoValue: IKnmDictionary, supervisionValue: IKnmDictionary) {
  yield put(supervisionDictionaryValueGet(knoValue.dictVersionId, supervisionValue.dictVersionId));
}
